import React, { createContext, useContext, useState } from 'react';
import { Translation } from './translationType';
import { useKioskConfiguration } from '../kioskConfiguration/KioskConfigurationContext';


interface Context {
  language: string;
  setLanguage: (language: string) => void;
  qtirLanguageId: number;
  translations: Translation;
}

const LanguageContext = createContext<Context | null>(null)

type Props = {
  children: React.ReactElement | React.ReactElement[],
  language: string
}

export const LanguageProvider = (props: Props): React.ReactElement => {
  const kioskConfigurationContext = useKioskConfiguration()
  const [language, setLanguage] = useState<string>(props.language);

  if (kioskConfigurationContext.kioskConfiguration === null) {
    return <></>
  }

  const selectedLanguageConfig = kioskConfigurationContext
    .kioskConfiguration
    .languages
    .find((l) => l.code === language)
  const translations = selectedLanguageConfig
    ? selectedLanguageConfig.translations
    : kioskConfigurationContext.kioskConfiguration.languages[0].translations

  const providerValue = {
    language,
    setLanguage,
    translations,
    qtirLanguageId: selectedLanguageConfig ? selectedLanguageConfig.qtirId : 0,
  }

  return (
    <LanguageContext.Provider value={providerValue}>
      { props.children }
    </LanguageContext.Provider>

  );
}

const useLanguage = (): Context => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }

  return context;
};

export default useLanguage;
